import React, { useState } from "react";
import { Table, Button, Popconfirm } from "antd";
import { useDispatch } from "react-redux";
import { deleteGlobalLeave, getGlobalLeaves } from "../../../../actions/globalLeaveAction";
import UpdateGlobalLeave from "./UpdateGlobalLeave";

export default function RenderTable({ data }) {
  const dispatch = useDispatch();
  const [editRecord, setEditRecord] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleDelete = async (id) => {
    await dispatch(deleteGlobalLeave(id));
    dispatch(getGlobalLeaves());
  };

  const handleEdit = (record) => {
    setEditRecord(record);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setEditRecord(null);
    setDrawerVisible(false);
  };

  const columns = [
    { title: "Title", dataIndex: "title", key: "title" },
    { title: "Start Date", dataIndex: "leaveStart", key: "leaveStart" },
    { title: "End Date", dataIndex: "leaveEnd", key: "leaveEnd" },
    { title: "Note", dataIndex: "note", key: "note" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button size="small" onClick={() => handleEdit(record)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this leave?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button danger size="small">
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 10 }}
      />

      {drawerVisible && editRecord && (
        <UpdateGlobalLeave
          visible={drawerVisible}
          onCancel={closeDrawer}
          editData={editRecord}
          setUpdatelist={() => dispatch(getGlobalLeaves())} 
        />
      )}
    </>
  );
}
